/**
 * Terminal notice for a link that cannot be used (PF-6119).
 *
 * Screen 1 replacement for an already-completed or invalid link. No phone form, no forward button —
 * there is nothing the patient can do here, and offering an input they cannot satisfy is what made
 * a second tap on the link look like a wrong phone number.
 */
import styled from 'styled-components';
import { space } from '../../../styles/onboardingUiTokens';
import { Body, H1, OnboardingBody, OnboardingFooter, OnboardingHeader, OnboardingLayout } from '../ui';

export type LinkNoticeScreenProps = {
  title: string;
  body: string;
};

export function LinkNoticeScreen({ title, body }: LinkNoticeScreenProps) {
  return (
    <OnboardingLayout currentStep={1} totalSteps={3} hideForward>
      <OnboardingHeader hideBackButton hideProgress />
      <OnboardingBody disableSupportHint>
        <ContentStack>
          <H1>{title}</H1>
          <Body variant="document">{body}</Body>
        </ContentStack>
      </OnboardingBody>
      <OnboardingFooter hidePrivacyNote />
    </OnboardingLayout>
  );
}

const ContentStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space.lg};
  padding-bottom: ${space.xl};
`;
